module.exports = __webpack_public_path__ + "img/KBANK.93e15944.png";